import InfoRow from './InfoRow';

export default InfoRow;
